import { TypePolicies } from '@apollo/client';

const typePolicies: TypePolicies = {};

export default typePolicies;
